import axios from "axios";
import { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2"
import 'react-phone-input-2/lib/style.css'

export const CountryPhoneInput = (props) => {
    const [country, setCountry] = useState("by");

    const getUserCountry = async () => {
        try {
            const ipData = await axios.get('https://api.ipify.org?format=json');
            if (ipData.data.ip) {
                const countryData = await axios.get(`https://api.ipinfo.io/lite/${ipData.data.ip}?token=${process.env.REACT_APP_IPINFO_TOKEN}`);
                if (countryData.data.country_code) {
                    setCountry((countryData.data.country_code ?? "by").toLowerCase());
                }
            }
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        getUserCountry();
    }, [])

    return (
        <PhoneInput
            inputStyle={{ width: "auto", ...props.inputStyle }}
            key={country}
            country={country}
            value={props.value}
            onChange={props.onChange}
            disabled={props.disabled}
            className={props.className}
            placeholder={props.placeholder}
        />
    )
}